import { render, staticRenderFns } from "./assist-case-confirm-distribution.vue?vue&type=template&id=c21588e0&scoped=true"
import script from "./assist-case-confirm-distribution.vue?vue&type=script&lang=ts"
export * from "./assist-case-confirm-distribution.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21588e0",
  null
  
)

export default component.exports